export default {
  generalSettings: {
    generalInformation: {
      containerLabel: 'General Information',
      menuList: {
        edit: 'Edit',
      },
      changePasswordModal: {
        title: 'Change Password',
        passwordContainerLabel: 'Password',
      },
      addPasswordModal: {
        title: 'Add Password',
        passwordContainerLabel: 'Password',
      },
      generalSettingsModal: {
        title: 'General Information',
        emailPhoneContainerLabel: 'New Email/Phone',
      },
    },
    securityWipeData: {
      containerLabel: 'Security wipe data',
      contentText: 'If  you wish to no longer be a part of hubmee, you can',
      contentLink: 'Remove data and Deactivate Account',
    },
    unverifiedPhoneNumber: {
      containerLabel: 'Unverified phone number',
      contentText: 'Please, type in verification code sent to {{phone}}',
    },
    unverifiedEmail: {
      containerLabel: 'Unverified email',
      contentText:
        'Please check your email and follow the instructions to verify your mail. If you did not receive an email or it is expired, you can resend one.',
    },
    deleteSocialNetwork: {
      containerLabel: 'Confirm',
      contentText:
        "If you delete data related to your {{provider}} account, you won't be able to sign in to hubmee using your {{provider}} account. Are you sure you want to continue?",
    },
    deleteSocialNetworkWithoutPassword: {
      containerLabel: 'Confirm',
      contentText:
        "If you delete data related to your {{provider}} account, you won't be able to sign in to hubmee using your {{provider}} account. Are you sure you want to continue?",
    },
    deleteAccountWithoutPassword: {
      containerLabel: 'Confirm',
      contentText:
        "We are sorry to hear that you want to deactivate your account. If there's anything we can do to convince you to stay, let us know. If you continue all your data will be lost forever.",
    },
  },
};
